import React, { useEffect, useRef } from "react"
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom"
import Dashboard from "./Dashboard"
import Welcome from "./Welcome"
import ProvaDetail from "./ProvaDetail"
import Configurador from "./Configurador"
import Simulado from "./Simulado"
import Resultado from "./Resultado"
import Plano from "./Plano"
import PlanoStatus from "./Plano/Status"
import Historico from "./Historico"
import Suporte from "./Suporte"
import SuporteTicket from "./Suporte/Ticket"
import Configuracoes from "./Configuracoes"
import { ToastProvider } from "./ui/Toast"
import { trackSignup, trackPageview } from "../lib/analytics"

// Reporta cada troca de rota ao GA4. Pula a primeira renderização porque o
// gtag('config') já contabiliza o page_view da URL de entrada.
function usePageviews() {
  const location = useLocation()
  const first = useRef(true)
  useEffect(() => {
    if (first.current) {
      first.current = false
      return
    }
    trackPageview(location.pathname + location.search)
  }, [location])
}

// No 1º acesso (nenhum simulado feito), leva o lead à landing interna de
// boas-vindas — mas só na ENTRADA. Depois disso ele navega livre (o "Ir para o
// painel" da própria página não deve rebater pra cá).
function useFirstTimeRedirect(firstTime: boolean) {
  const navigate = useNavigate()
  const done = useRef(false)
  useEffect(() => {
    if (done.current) return
    done.current = true
    if (!firstTime) return
    const path = window.location.pathname
    if (path === "/" || path === "/dashboard") {
      navigate(`/bem-vindo${window.location.search}`, { replace: true })
    }
  }, [firstTime, navigate])
}

export default function App({ firstTime = false }: { firstTime?: boolean }) {
  usePageviews()
  useFirstTimeRedirect(firstTime)

  // Cadastro novo cai em /dashboard?signup=1 (email/senha e Google OAuth).
  // Dispara a conversão uma vez e limpa o parâmetro da URL.
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    if (params.get("signup") === "1") {
      trackSignup()
      params.delete("signup")
      const qs = params.toString()
      window.history.replaceState(null, "", window.location.pathname + (qs ? `?${qs}` : ""))
    }
  }, [])

  return (
    <ToastProvider>
      <Routes>
        <Route path="/bem-vindo" element={<Welcome />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/prova/:id" element={<ProvaDetail />} />
        <Route path="/prova/:id/configurar" element={<Configurador />} />
        <Route path="/simulado/:id" element={<Simulado />} />
        <Route path="/simulado/:id/resultado" element={<Resultado />} />
        <Route path="/plano" element={<Plano />} />
        <Route path="/plano/:status" element={<PlanoStatus />} />
        <Route path="/historico" element={<Historico />} />
        <Route path="/suporte" element={<Suporte />} />
        <Route path="/suporte/:id" element={<SuporteTicket />} />
        <Route path="/configuracoes" element={<Configuracoes />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </ToastProvider>
  )
}
